<template>
  <div>
    <help-list :titleText="title"></help-list>
  </div>
</template>

<script>
/* global PUBLIC_EMPTY_TITLE */

import HelpList from '@/components/HelpList.vue';

export default {
  name: 'Help',
  components: {
    HelpList,
  },
  data() {
    return {
      title: PUBLIC_EMPTY_TITLE === '1' ? '意见反馈' : '帮助和反馈',
    };
  },
};
</script>
